// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class CaseDispatchToProviderResource extends Resource {
    basePath: string = 'cases/dispatch-to-provider/';

    objectPath: string = 'cases/dispatch-to-provider/{ident}/';
}
